/* eslint-disable */
import React, { Component } from "react";
import { connect } from "react-redux";
import MainContent from "../MainContent/MainContent";
import SettingsContainer from "../SettingsContainer/SettingsContainer";
import SidebarContainer from "../Sidebar/SidebarContainer";
import LexisNexisOfflinePost from "../LexisNexisOfflinePost";
import { fetchMetaData, gettingStartedProgress, updateRouteValues, sseTrigger, getNotificationCounter } from "../../actions/globalAction";
import { getAccessToken } from "../../actions/utils.js";
import { getUrl } from "../../actions/urls";
import { fetchFiltersList, setFilterListFetchedStatus } from "../../actions/filterSettingActions";
import { getTeamsIBelongTo } from "../../actions/rawDataAction";
import Loader from "../Loader/Loader";
import UpgradePackageModal from "../SubscriptionModule/UpgradePackageModal";

import "./AppContainer.scss";
// import ReactGA from "react-ga";
// import loaderLogo from "./loader-logo.png";
// var moment = require("moment");
import { Route, Switch, Redirect, withRouter } from "react-router-dom";
import "./ProtectedRoutesContainer.scss";
import UnverifiedAccountPage from "./UnverifiedAccountPage";
import billingPageRoute from "../SubscriptionModule/billingPageRoute";

import { isMobile } from "react-device-detect";
import SignUpSteps from "./SignUpSteps";
import CompanySwitchModal from "./CompanySwitchModal";
import RouteWrapper from "./RouteWrapper";
// import CompanyDetailsForms from "./UserProfileSetup/CompanyDetailsForm/CompanyDetailsForms";
import ProfileSetupWrapper from "./UserProfileSetup/ProfileSetupWrapper";
import SuccessPage from "./UserProfileSetup/Success/SuccessPage";
import TrialPeriodCompletedModal from "./TrialPeriodCompleted/TrialPeriodCompletedModal";
import SocialTokensTwitterOAuth from "../MainContent/Tokens/SocialTokensTwitterOAuth";
import ProfileContainer from "../MainContent/Profile/ProfileContainer";
import AIModal from "../MainContent/InsightsTab/AIModal";
import DraggableAIIcon from "../MainContent/InsightsTab/DraggableAIIcon";
import { ReactComponent as AI_icon } from "../../assets/svg/AI-icon.svg";

class AppContainer extends Component {
    constructor(props) {
        super(props);

        this.state = {
            accessToken: localStorage.getItem("accessToken"),
            showPageReloadModal: false,
            data: {},
            isModalOpen: false,
        };
        this.localStorageChangeEvent = React.createRef();
        this.eventSource = new EventSource(`${getUrl("server_side_events")}?access-token=${getAccessToken()}`);
    }

    componentDidMount() {
        //ServerSentEvent Function Start
        // console.log("first", zE);
        let source = this.eventSource;
        // const source = new EventSource(`${getUrl("server_side_events")}?access-token=${getAccessToken()}`);

        source.addEventListener("open", () => {
            console.log("SSE opened!", source);
        });

        source.addEventListener("notification", (event) => {
            console.log("SSE New data!", event.data);
            this.props.sseTrigger(JSON.parse(event.data));
        });
        // source.addEventListener("error", (e) => {
        //     console.log("tttttt", e, source);
        // });

        //ServerSentEvent Function End

        if (!(window.location.href.indexOf("lnoffline") > -1)) {
            this.props.fetchMetaData().then((res) => {
                let roles = res?.value?.user?.roles;
                if (roles && roles.length === 1 && roles[0] === "token_provider") {
                    this.props.setFilterListFetchedStatus();
                    if (!window.location.href.indexOf("social-tokens")) this.props.history.replace("/social-tokens");
                } else {
                    this.props.fetchFiltersList();
                    this.props.getTeamsIBelongTo();
                    this.props.gettingStartedProgress();
                }
            });
        }

        zE("webWidget", "updateSettings", {
            color: {
                theme: "#268af6",
            },
        });

        this.localStorageChangeEvent = window.addEventListener("storage", () => {
            let accessToken = localStorage.getItem("accessToken");

            if (accessToken) {
                if (accessToken !== this.state.accessToken) {
                    this.setState({ showPageReloadModal: true });
                }
            } else {
                window.location.reload();
            }
        });
    }

    async componentDidUpdate(prevProps) {
        if (prevProps.location.pathname != window.location.pathname) {
            let route = {
                to: window.location.pathname,
                from: prevProps.location.pathname,
            };
            await this.props.updateRouteValues(route);

            // console.log("firssset", this.props.sseData, Object.keys(this.props.sseData).length, prevProps.location.pathname);

            await this.props.sseTrigger({});
            await this.props.getNotificationCounter();
        }
    }

    componentWillUnmount() {
        this.eventSource.close();
        window.removeEventListener("storage", this.localStorageChangeEvent);
    }

    render() {
        let trialPeriodEndedForFreeUser =
            this.props.packageObj?.package_code && this.props.packageObj?.package_code === "free" && this.props.freeTrialDaysLeft <= 0;
        if (!(window.location.href.indexOf("lnoffline") > -1)) {
            return (
                <>
                    <main>
                        <div className="insights__icon--top">
                            <DraggableAIIcon
                                handleModal={() => {
                                    this.setState({ isModalOpen: !this.state.isModalOpen });
                                }}
                            />
                        </div>
                        <AIModal
                            isOpen={this.state.isModalOpen}
                            onClose={() => {
                                this.setState({ isModalOpen: !this.state.isModalOpen });
                            }}
                        />
                        <Switch>
                            {this.props.company && this.props.fetchedFiltersList ? (
                                <Route
                                    path="/"
                                    render={(props) => (
                                        <>
                                            {!isMobile &&
                                                this.props.company.is_profile_setup === 1 && // need to change this to 1
                                                this.props.location.pathname.split("/")[1] !== "subscription" &&
                                                !this.props.location.pathname.includes("/profile-setup") &&
                                                !this.props.location.pathname.includes("/signin-interstitial") &&
                                                !trialPeriodEndedForFreeUser && <SidebarContainer {...props} />}
                                            <Switch>
                                                <Redirect from="/:url*(/+)" to={this.props.location.pathname.slice(0, -1)} />
                                                {/* <Route
                                                    exact
                                                    path="/company-details"
                                                    render={(props) => <SignUpSteps {...props} user={this.props.user} company={this.props.company} />}
                                                /> */}
                                                <Route
                                                    // exact
                                                    path="/profile-setup"
                                                    render={(props) => (
                                                        <ProfileSetupWrapper
                                                            {...props}
                                                            user={this.props.user}
                                                            isMobile={isMobile}
                                                            company={this.props.company}
                                                        />
                                                    )}
                                                />
                                                <RouteWrapper path="/social-tokens/oauth-callback" component={SocialTokensTwitterOAuth} />

                                                {/* {this.props.company.is_profile_setup !== 1 && <Redirect to="/company-details" />} // need to change this should redirect to /company */}
                                                {this.props.company.is_profile_setup !== 1 && <Redirect to="/profile-setup" />}
                                                <Route
                                                    path="/completed"
                                                    //  component={SuccessPage}
                                                    render={(props) => <SuccessPage {...props} isMobile={isMobile} />}
                                                />

                                                <Route
                                                    path="/subscription"
                                                    render={(props) => <SignUpSteps {...props} user={this.props.user} company={this.props.company} />}
                                                />
                                                {/* {this.props.packageObj.package_code === "free" && <Redirect to="/subscription" />} */}
                                                <Route
                                                    exact
                                                    path="/signin-interstitial"
                                                    render={(props) => (
                                                        <UnverifiedAccountPage
                                                            {...props}
                                                            user={this.props.user}
                                                            packageObj={this.props.packageObj}
                                                            company={this.props.company}
                                                        />
                                                    )}
                                                />
                                                {isMobile && <Redirect to="/signin-interstitial" />}
                                                <RouteWrapper path="/billing/" component={billingPageRoute} />
                                                <RouteWrapper path="/settings/" component={SettingsContainer} />
                                                <RouteWrapper path="/profile" component={ProfileContainer} />

                                                {trialPeriodEndedForFreeUser ? (
                                                    <TrialPeriodCompletedModal open={trialPeriodEndedForFreeUser} />
                                                ) : (
                                                    <RouteWrapper path="/" component={MainContent} />
                                                )}
                                            </Switch>
                                            <UpgradePackageModal />
                                            <CompanySwitchModal open={this.state.showPageReloadModal} />
                                        </>
                                    )}
                                />
                            ) : (
                                <Loader className="fullpage-loader" location={this.props.location} />
                            )}
                        </Switch>
                    </main>
                </>
            );
        } else {
            return <LexisNexisOfflinePost />;
        }
    }
}

const mapStateToProps = (state) => {
    return {
        company: state.globalReducer.company,
        packageObj: state.globalReducer.packageObj,
        user: state.globalReducer.user,
        fetchedFiltersList: state.filterSettingReducer.fetchedFiltersList,
        freeTrialDaysLeft: state.globalReducer.freeTrialDaysLeft,
        sseData: state.globalReducer.sseData,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        fetchMetaData: () => dispatch(fetchMetaData()),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        fetchFiltersList: () => dispatch(fetchFiltersList()),
        setFilterListFetchedStatus: () => dispatch(setFilterListFetchedStatus()),
        getTeamsIBelongTo: (callback) => dispatch(getTeamsIBelongTo(callback)),
        updateRouteValues: (args) => dispatch(updateRouteValues(args)),
        sseTrigger: (args) => dispatch(sseTrigger(args)),
        getNotificationCounter: () => dispatch(getNotificationCounter()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(AppContainer));
